import axios from "axios";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { findDOMNode, createPortal } from "react-dom";
import {
  AiOutlineFullscreen,
  AiOutlineAudioMuted,
  AiOutlineAudio,
} from "react-icons/ai";
import { FaBug, FaPause, FaPlay, FaTimesCircle } from "react-icons/fa";
import {
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import { connect, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import screenfull from "screenfull";
import InputField from "../components/InputField";
import VideoPlayer from "../components/VideoPlayerOld";
import { SaveMatchString } from "../redux/actions/analysisAction";
import {
  ClearSeekFlag,
  LoadVideoUrl,
  SetControllerToggle,
  SetVideoControl,
  UpdateVideoTime,
} from "../redux/actions/controlAction";

import Logo from "../assets/Logo";
import SimpleButton from "../components/SimpleButton";
import Duration from "../components/VideoPlayer(new)/DurationOld";
import { FaStopwatch } from "react-icons/fa";
import { SSENSE_URL, MAIN_API } from "../config/stepoutAPI";
import { FaArrowRight, FaChevronRight } from "react-icons/fa";
import zIndex from "@mui/material/styles/zIndex";
import ReactModal from "react-modal";
import * as Ably from "ably";
import {
  AblyProvider,
  ChannelProvider,
  useChannel,
  useChannelStateListener,
  useConnectionStateListener,
  useAbly,
} from "ably/react";
import {
  Box,
  Stack,
  Typography,
  Button,
  IconButton,
  TextField,
  InputAdornment,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Skeleton,
  Tooltip,
} from "@mui/material";
import {
  ArrowBack,
  PlayArrow,
  Pause,
  Fullscreen,
  VolumeUp,
  VolumeOff,
  Timer,
  NavigateNext,
  BugReport,
  RocketLaunch,
  Link as LinkIcon,
  InfoOutlined,
  WifiOff,
  Refresh,
  KeyboardAlt,
  VideocamOff,
} from "@mui/icons-material";
import { debounce, throttle } from "lodash";
import { trackEvent } from "../utils/mixpanel";
import { publishVideoTimestamp, getAblyClient } from "../utils/ablyManager";
import { benchmarkService } from "../utils/benchmarkService";
import { isAblyVideoSyncEnabled } from "../persistence/firestore/ablyVideoSyncConfig";
import VideoTimelineEditor from "../components/VideoTimelineEditor";
import useAnalysisRoom from "../hooks/useAnalysisRoom";
import { ROLE_VIDEO } from "../utils/analysisRoom";

const SPEEDS = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75];

// Ably connection states that mean "no realtime link right now".
const ABLY_OFFLINE_STATES = ["disconnected", "suspended", "failed", "closed"];

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const VideoTab = (props) => {
  const reduxState = useSelector((state) => state);

  const [loading, setLoading] = useState(true);
  const [url, setUrl] = useState("");
  const [playing, setPlaying] = useState(false);
  const [ready, setReady] = useState(false);
  const [layoutWidth, setLayoutWidth] = useState(window.innerWidth);
  const [speed, setSpeed] = useState(1);
  const [matchDetails, setMatchDetails] = useState(null);
  const [duration, setDuration] = useState(null);
  const [seeking, setSeeking] = useState(false);
  const [jumpTo, setJumpTo] = useState("");
  const [playerIsFullscreen, setPlayerIsFullscreen] = useState(false);
  const [showControls, setShowControl] = useState(false);
  const [matchVideoData, setMatchVideoData] = useState(null);
  // No video is attached to this match — the player area shows an empty state.
  const [noMatchVideo, setNoMatchVideo] = useState(false);

  const [time, setTime] = useState(0);
  const [isActive, setIsActive] = useState(false);
  // TAT only accrues while both analyst screens are connected (see below).
  const tatLinkReadyRef = useRef(false);
  const intervalRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [ablyMessagesEvent, setAblyMessagesEvent] = useState("");
  const [analysisInfoDetails, setAnalysisInfoDetails] = useState();
  const [dialogBoxText, setDialogBoxText] = useState("");
  const [status, setStatus] = useState(0);
  const [isMute, setIsMute] = useState(false);
  const [showTimeline, setShowTimeline] = useState(false);
  const [showUrlInput, setShowUrlInput] = useState(false);
  const timelineState = useRef();

  const history = useHistory();
  const location = useLocation();
  const showDeploymentBtn = location.state?.TechQCSubmit;

  //ably channel for webhook
  const { channel } = useChannel(
    "analyst_portal_" + props.analystId,
    // asdasd,
    (message) => {
      // Only process unnamed messages
      if (message.name === "" || message.name === "match_analysis_event") {
        try {
          const event = JSON.parse(message.data);

          if (event?.event) {
            handleIncomingEvent(event.event);
          }
        } catch (err) {
          console.error("Invalid JSON in message.data", message.data);
        }
      }
    }
  );

  // Debounced update to avoid flooding state
  const handleIncomingEvent = useCallback(
    debounce((eventData) => {
      setAblyMessagesEvent({
        message: eventData,
        isInitial: false,
      });
    }, 100), // You can adjust this to a slightly higher value like 200ms if needed
    []
  );

  useEffect(() => {
    if (
      isActive &&
      status !== 9 &&
      status !== 8 &&
      status !== 6 &&
      status !== 3
    ) {
      let counter = 0;

      const intervalId = setInterval(() => {
        // Keyboard screen gone or realtime link down — hold the clock, do not
        // count time the analyst cannot actually be tagging in.
        if (!tatLinkReadyRef.current) return;

        setTime((prevTime) => {
          const newTime = prevTime + 1;
          counter += 1;

          // Call the API after every 30 seconds
          if (counter === 15) {
            updateTat(newTime); // Using the latest state value
            // localStorage.setItem("videoTabTat", JSON.stringify(newTime));
            localStorage.setItem(
              "videoTabTat",
              JSON.stringify({ [match_id]: newTime })
            );
            counter = 0;
          }

          return newTime;
        });
      }, 1000); // Update every second

      return () => clearInterval(intervalId);
    }
  }, [isActive, status]);
  
  const formatTimeFromSeconds = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  const {
    seekToTime,
    UpdateVideoTime,
    SetVideoControl,
    videoTime,
    videoControl,
  } = props;
  const query = useQuery();
  const match_id = query.get("match_id");

  const playerRef = useRef();

  // Keep the timeline engine in sync with play/pause.
  useEffect(() => {
    if (videoControl) timelineState.current && timelineState.current.play();
    else timelineState.current && timelineState.current.pause();
  }, [videoControl]);

  const updateTat = useCallback(
    async (currTime) => {
      try {
        const res = await axios.post(
          `${MAIN_API}update_match_analysis_tat/`,
          {
            match_id: parseInt(match_id),
            analyst_id: parseInt(props.analystId),
            tat: parseInt(currTime),
          },
          {
            headers: {
              Authorization: `ANALYST ${reduxState?.auth?.token}`,
            },
          }
        );
        return res.response_data;
      } catch (err) {
        console.error(err);
      }
    },
    [match_id, props.analystId, reduxState.auth.token]
  );

  // useEffect(() => {
  //   if (isActive) {
  //     let counter = 0;

  //     const intervalId = setInterval(() => {
  //       setTime((prevTime) => {
  //         const newTime = prevTime + 1;
  //         counter += 1;

  //         // Call the API after every 30 seconds
  //         if (counter === 30) {
  //           updateTat(newTime); // Using the latest state value
  //           localStorage.setItem(
  //             "videoTabTat",
  //             JSON.stringify({ [match_id]: newTime })
  //           );
  //           counter = 0;
  //         }

  //         return newTime;
  //       });
  //     }, 1000); // Update every second

  //     return () => clearInterval(intervalId);
  //   }
  // }, [isActive, match_id, updateTat]);

  //api call to push tat when a trigger from mobile will come
  // eg: keyboard screen has been opened, close , analysis done , browser closed

  // analysis_event_status: "pause"
  // current_analysis_time: "2024-10-26T14:02:34.744000"
  // total_video_duration_in_sec: 5406
  const getAnalysisStatus = useCallback(async () => {
    try {
      const res = await axios.post(
        `${MAIN_API}get_matchwise_analysis_status/`,
        {
          match_id: parseInt(match_id),
          analyst_id: parseInt(props.analystId),
        },
        {
          headers: {
            Authorization: `ANALYST ${reduxState?.auth?.token}`,
          },
        }
      );
      setAnalysisInfoDetails(res.data.response_data);
      // setting initial event
      setAblyMessagesEvent({
        message: res.data.response_data.analysis_event_status,
        isInitial: true,
      });
      return res.response_data;
    } catch (err) {
      console.error(err);
    }
  }, [match_id, props.analystId, reduxState.auth.token]);

  useEffect(() => {
    getAnalysisStatus();
  }, [getAnalysisStatus]);

  const getAnalysisTat = useCallback(async () => {
    try {
      const res = await axios.post(
        `${MAIN_API}get_analysis_tat/`,
        {
          match_id: parseInt(match_id),
          analyst_id: parseInt(props.analystId),
        },
        {
          headers: {
            Authorization: `ANALYST ${reduxState?.auth?.token}`,
          },
        }
      );
      const tat = res?.data?.analysis_tat;
      return Number(tat) > 0 ? Number(tat) : null;
    } catch (err) {
      console.error(err);
      return null;
    }
  }, [match_id, props.analystId, reduxState.auth.token]);

  useEffect(() => {
    trackEvent().track('entered_video_screen', { match_id: match_id });
  }, []);

  // Mixpanel – TAT started / stopped, driven by isActive so it only fires on real state changes
  const tatMountedRef = useRef(false);
  useEffect(() => {
    if (!tatMountedRef.current) {
      tatMountedRef.current = true;
      return;
    }
    if (isActive) {
      trackEvent().track('tat_started', { match_id: match_id });
    } else {
      trackEvent().track('tat_stopped', { match_id: match_id, elapsed_seconds: time });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActive]);

  useEffect(() => {
    if (ablyMessagesEvent) {
      if (
        ablyMessagesEvent.message === "start" ||
        ablyMessagesEvent.message === "resume"
      ) {
        setIsActive(true);
      } else if (ablyMessagesEvent.message === "pause") {
        setIsActive(false);
      } else {
        setIsActive(false);
      }

      // dialog box logic
      if (
        ablyMessagesEvent.isInitial &&
        (ablyMessagesEvent.message === "start" ||
          ablyMessagesEvent.message === "resume")
      ) {
        setIsModalOpen(false);
      }

      if (
        ablyMessagesEvent.isInitial &&
        ablyMessagesEvent.message === "pause"
      ) {
        setIsModalOpen(true);
        setDialogBoxText("Open Analysis Keyboard to continue.");
      } else if (
        !ablyMessagesEvent.isInitial &&
        ablyMessagesEvent.message === "pause"
      ) {
        updateTat(time);
        localStorage.setItem(
          "videoTabTat",
          JSON.stringify({ [match_id]: time })
        );
        setIsModalOpen(true);
        setDialogBoxText(
          "Match Analysis is paused from your Mobile Device. Open Analysis Keyboard to continue."
        );
      } else if (
        ablyMessagesEvent.isInitial &&
        ablyMessagesEvent.message === null
      ) {
        setDialogBoxText("Open Analysis Keyboard to continue.");
      }
    }
  }, [ablyMessagesEvent, match_id, time, updateTat]);

  const latestVideoTimeRef = useRef(props.videoTime);

  // Keep ref in sync with latest video time
  useEffect(() => {
    latestVideoTimeRef.current = props.videoTime;
  }, [props.videoTime]);

  // Mirrors Analyse.js — Ably video-sync is controlled remotely from Firestore
  // (appConfig/ablyVideoSync), so publisher and subscriber agree on transport mode.
  const [useAblyVideoSync, setUseAblyVideoSync] = useState(false);
  useEffect(() => {
    if (!match_id) return;
    let cancelled = false;
    isAblyVideoSyncEnabled(match_id).then((enabled) => {
      if (!cancelled) setUseAblyVideoSync(enabled);
    });
    return () => {
      cancelled = true;
    };
  }, [match_id]);


  

  // Analysis room — presence tells us whether the Analysis Keyboard screen for
  // this same match + analyst is actually open.
  const { peerConnected: keyboardScreenConnected } = useAnalysisRoom(
    match_id,
    props.analystId,
    ROLE_VIDEO
  );

  // ─── Ably connection watchdog ──────────────────────────────────────────────
  // Both realtime clients matter here: the provider client (webhook events) and
  // the ablyManager client (video timestamp publishes). If either drops while
  // the video is playing we pause playback, warn the analyst, and auto-resume
  // once the connection is back.
  const providerAblyClient = useAbly();
  const [ablyOffline, setAblyOffline] = useState(false);
  const [ablyRetrying, setAblyRetrying] = useState(false);
  const ablyOfflineRef = useRef(false);
  const resumeAfterReconnectRef = useRef(false);
  const retryTimerRef = useRef(null);
  const videoControlRef = useRef(props.videoControl);

  const evaluateConnectionRef = useRef(null);

  // Both screens present and the realtime link up — the only state in which
  // the TAT clock is allowed to run.
  useEffect(() => {
    tatLinkReadyRef.current = keyboardScreenConnected && !ablyOffline;
  }, [keyboardScreenConnected, ablyOffline]);

  // Force the underlying element to stop — the `playing` prop alone will not
  // re-pause a video that was started from YouTube's own / native controls.
  const hardPausePlayer = useCallback(() => {
    try {
      const internal = playerRef.current?.getInternalPlayer?.();
      if (internal?.pauseVideo) internal.pauseVideo();
      else if (internal?.pause) internal.pause();
    } catch (err) {
      console.error("Failed to pause player", err);
    }
    timelineState.current && timelineState.current.pause();
  }, []);

  // YouTube's own fullscreen button puts the <iframe> itself in the top layer,
  // and nothing in this document can be painted inside it. Leave fullscreen so
  // the banner is visible — playback is stopping anyway.
  const exitForeignFullscreen = useCallback(() => {
    try {
      if (
        screenfull.isEnabled &&
        screenfull.isFullscreen &&
        screenfull.element?.tagName === "IFRAME"
      ) {
        const exited = screenfull.exit();
        if (exited && typeof exited.catch === "function") {
          exited.catch(() => {});
        }
      }
    } catch (err) {
      console.error("Failed to exit fullscreen", err);
    }
  }, []);

  useEffect(() => {
    videoControlRef.current = props.videoControl;
    // Playback is not allowed while the link is down — whatever asked for it
    // (keyboard, control bar, native controls, a remote action) gets undone.
    if (ablyOfflineRef.current && props.videoControl) {
      SetVideoControl(false);
      hardPausePlayer();
    }
  }, [props.videoControl, SetVideoControl, hardPausePlayer]);

  const getAblyConnections = useCallback(() => {
    const clients = [providerAblyClient, getAblyClient()].filter(Boolean);
    // Both entries can resolve to the same instance depending on how the app boots.
    return clients.filter((c, i) => clients.indexOf(c) === i);
  }, [providerAblyClient]);

  useEffect(() => {
    const clients = getAblyConnections();
    if (!clients.length) return;

    const evaluate = () => {
      const offline =
        !navigator.onLine ||
        clients.some((c) => ABLY_OFFLINE_STATES.includes(c.connection?.state));
      if (offline === ablyOfflineRef.current) return;
      ablyOfflineRef.current = offline;
      setAblyOffline(offline);

      if (offline) {
        if (videoControlRef.current) {
          resumeAfterReconnectRef.current = true;
          SetVideoControl(false);
        }
        // Native/YouTube controls can already be mid-play — stop the element itself.
        hardPausePlayer();
        exitForeignFullscreen();
        trackEvent().track("ably_connection_lost", { match_id: match_id });
      } else {
        setAblyRetrying(false);
        if (resumeAfterReconnectRef.current) {
          resumeAfterReconnectRef.current = false;
          SetVideoControl(true);
        }
        trackEvent().track("ably_connection_restored", { match_id: match_id });
      }
    };

    evaluateConnectionRef.current = evaluate;
    clients.forEach((c) => c.connection.on(evaluate));
    window.addEventListener("online", evaluate);
    window.addEventListener("offline", evaluate);
    evaluate();

    return () => {
      clients.forEach((c) => c.connection.off(evaluate));
      window.removeEventListener("online", evaluate);
      window.removeEventListener("offline", evaluate);
      evaluateConnectionRef.current = null;
    };
  }, [
    getAblyConnections,
    SetVideoControl,
    match_id,
    hardPausePlayer,
    exitForeignFullscreen,
  ]);

  useEffect(
    () => () => {
      if (retryTimerRef.current) clearTimeout(retryTimerRef.current);
    },
    []
  );

  // Manual retry — Ably already auto-retries, this just forces an immediate attempt.
  // The connection listener above clears `ablyRetrying` and resumes playback on success.
  const handleAblyRetry = useCallback(() => {
    setAblyRetrying(true);
    getAblyConnections().forEach((c) => {
      try {
        if (ABLY_OFFLINE_STATES.includes(c.connection?.state)) c.connection.connect();
      } catch (err) {
        console.error("Ably reconnect failed", err);
      }
    });
    evaluateConnectionRef.current && evaluateConnectionRef.current();
    if (retryTimerRef.current) clearTimeout(retryTimerRef.current);
    retryTimerRef.current = setTimeout(() => setAblyRetrying(false), 6000);
  }, [getAblyConnections]);

  // The fullscreen element is the player node itself, so a normally-rendered
  // banner is hidden behind the top layer. Portal it into a host div parked
  // inside whatever element is currently fullscreen.
  const [fullscreenHost, setFullscreenHost] = useState(null);
  useEffect(() => {
    if (!screenfull.isEnabled) return;
    let host = null;

    const removeHost = () => {
      if (host && host.parentNode) host.parentNode.removeChild(host);
      host = null;
    };

    const onChange = () => {
      removeHost();
      if (screenfull.isFullscreen && screenfull.element) {
        host = document.createElement("div");
        // fixed + top layer => positioned against the screen; clicks only land on the banner.
        host.style.cssText =
          "position:fixed;inset:0;pointer-events:none;z-index:2147483647;";
        screenfull.element.appendChild(host);
      }
      setFullscreenHost(host);
    };

    screenfull.on("change", onChange);
    onChange();

    return () => {
      screenfull.off("change", onChange);
      removeHost();
    };
  }, []);

  const didMountVideoControl = useRef(false);
  useEffect(() => {
    // Skip the pause-branch push on the very first render — no real pause has
    // happened yet and getCurrentTime() is still null (causes a spurious push).
    if (!didMountVideoControl.current) {
      didMountVideoControl.current = true;
      if (!props.videoControl) return;
    }
    if (!props.videoControl) {
      // Use getCurrentTime() for the most accurate position — avoids the 300ms
      // onProgress lag, which matters after a YouTube native seek where the user
      // pauses before the next progress tick arrives.
      const pauseTs =
        playerRef.current?.getCurrentTime?.() ?? latestVideoTimeRef.current;

      // Publish pause event to Ably so InputBoard gets the frozen timestamp instantly.
      if (useAblyVideoSync) {
        const _publishedAt = benchmarkService.recordAblyPublish(pauseTs);
        publishVideoTimestamp(match_id, props.analystId, pauseTs, false, _publishedAt);
      }

      return;
    }

    if (useAblyVideoSync) {
      // ABLY PATH — real-time publish fires on every onProgress tick (see JSX below).
      // REST runs every 30 seconds as a checkpoint to keep last_timestamp on the server current
      // (§3.3 / Phase 4). ~180 requests/session vs ~5,400 with 1-second polling.
      const checkpoint = setInterval(() => {
        const data = new FormData();
        data.append("match_id", match_id);
        data.append("analyst_id", props.analystId);
        data.append("video_timestamp", latestVideoTimeRef.current);
        axios.post(`${SSENSE_URL}push_match_video_data/v2/`, data);
        benchmarkService.recordRestPush(latestVideoTimeRef.current);
      }, 30000);
      return () => clearInterval(checkpoint);
    } else {
      // REST PATH (legacy / unchanged) — POST every 1 second while playing.
      const interval = setInterval(() => {
        const data = new FormData();
        data.append("match_id", match_id);
        data.append("analyst_id", props.analystId);
        data.append("video_timestamp", latestVideoTimeRef.current);
        axios.post(`${SSENSE_URL}push_match_video_data/v2/`, data);
        benchmarkService.recordRestPush(latestVideoTimeRef.current);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [props.videoControl, match_id, props.analystId, useAblyVideoSync]);

  // On mount: reset any stale timestamp on the server for this match + analyst.
  // Kept for both modes — server-side reset is always useful.
  useEffect(() => {
    let data = new FormData();
    data.append("match_id", match_id);
    data.append("analyst_id", props.analystId);
    data.append("video_timestamp", "0");
    axios.post(`${SSENSE_URL}push_match_video_data/v2/`, data);
  }, [match_id, props.analystId]);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  if (screenfull.isEnabled) {
    screenfull.on("change", () => {
      setPlayerIsFullscreen(screenfull.isFullscreen);
    });
  }

  const full = () => {
    if (screenfull.isEnabled) {
      screenfull.request(findDOMNode(playerRef.current));
    }
  };

  const handleMute = () => {
    setIsMute(!isMute);
  };

  const jumpManually = (str) => {
    const jumpInputList = str.split(":");
    if (jumpInputList.length < 3) {
      return;
    }
    const totalSecends =
      parseInt(jumpInputList[0]) * 60 * 60 +
      parseInt(jumpInputList[1]) * 60 +
      parseInt(jumpInputList[2]);
    playerRef.current.seekTo(parseFloat(totalSecends));
    if (!ablyOfflineRef.current) setPlaying(true);
    setJumpTo("");
  };

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      // Prevent the default behavior
      // localStorage.setItem("videoTabTat", JSON.stringify(time));
      event.preventDefault();
      event.returnValue = ""; // Required for modern browsers
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    // Cleanup the event listener
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  // Redux keeps videoUrl/videoControl across matches — stop playback while the
  // new match's video is being resolved so nothing stale autoplays.
  useEffect(() => {
    SetVideoControl(false);
    setReady(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [match_id]);

  useEffect(() => {
    if (match_id && props.all_matches) {
      const details = props.all_matches?.find((m) => {
        return m.id.toString() === match_id;
      });
      setStatus(details?.status);
      const video = details?.youtube_videos;
      const matchVideo = video?.find((item) => {
        return item?.matches?.[0].toString() === match_id.toString();
      });
      if (matchVideo?.url) {
        setNoMatchVideo(false);
        setMatchVideoData(matchVideo);
        props.LoadVideoUrl(matchVideo.url);
      } else {
        // videoUrl lives in Redux and survives navigation — without this the
        // previous match's video keeps playing on a match that has none.
        setNoMatchVideo(true);
        setMatchVideoData(null);
        props.LoadVideoUrl("");
        setReady(false);
        setDuration(null);
        SetVideoControl(false);
        UpdateVideoTime(0);
      }
      if (details) {
        setMatchDetails(details);
        const localTat =
          JSON.parse(localStorage.getItem("videoTabTat"))?.[match_id] || 0;
        getAnalysisTat().then((apiTat) => {
          if (localTat > 0 && apiTat > 0) {
            setTime(Math.max(localTat, apiTat));
          } else if (localTat > 0) {
            setTime(localTat);
          } else if (apiTat > 0) {
            setTime(apiTat);
          } else {
            setTime(details?.analyst_tat);
          }
        });
      } else {
        setMatchDetails(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [match_id, props.all_matches, getAnalysisTat]);

  const handleSeekMouseDown = (e) => {
    setSeeking(true);
  };

  const handleSeekChange = (e) => {
    UpdateVideoTime(parseFloat(e.target.value));
  };

  const handleSeekMouseUp = (e) => {
    setSeeking(false);
    playerRef.current.seekTo(parseFloat(e.target.value));
    // Hand the keyboard back to the page — otherwise the slider keeps focus.
    e.target.blur();
  };

  useEffect(() => {
    if (seekToTime) {
      setSeeking(true);
      UpdateVideoTime(seekToTime);
      playerRef.current.seekTo(seekToTime);
      setSeeking(false);
    }
  }, [UpdateVideoTime, seekToTime]);

  const initialHandleUserKeyPress = useCallback(
    (event) => {
      const { key, keyCode, target } = event;

      // Never hijack keys meant for a text field (jump-to, custom URL).
      // The seekbar is an <input type="range"> that keeps focus after a drag —
      // it must NOT swallow play/pause and seek keys, so it is excluded here.
      const tag = target?.tagName;
      const isTextField =
        (tag === "INPUT" && target?.type !== "range") ||
        tag === "TEXTAREA" ||
        target?.isContentEditable;
      if (isTextField) return;

      if (keyCode === 32) {
        // A focused Play/Pause button would also be activated by Space, which
        // toggles a second time and cancels this one out.
        event.preventDefault();
        // No playback while the realtime link is down.
        if (ablyOfflineRef.current) {
          hardPausePlayer();
          return;
        }
        SetVideoControl(!videoControl);
      }
      // Arrow seek = ±5s.
      // For YouTube, when the player iframe itself is focused (incl. fullscreen),
      // YouTube's own keyboard already seeks ±5s and our window handler never
      // receives the key — so let native handle it. Only seek ourselves when the
      // iframe is NOT the focused element, so the two never stack into a 10s jump.
      if (keyCode === 39 || keyCode === 37) {
        if (!playerRef.current) return;
        // A focused seekbar would otherwise step its own value as well.
        if (tag === "INPUT" && target?.type === "range") event.preventDefault();
        if (isYoutubeUrl() && document.activeElement?.tagName === "IFRAME") return;
        const cur = playerRef.current.getCurrentTime?.() ?? videoTime ?? 0;
        const next = keyCode === 39 ? cur + 5 : Math.max(0, cur - 5);
        playerRef.current.seekTo(parseFloat(next));
      }
    },
    [SetVideoControl, videoControl, videoTime, hardPausePlayer]
  );

  const getWidth = () => {
    setLayoutWidth(window.innerWidth);
  };

  const gotoSubmitHandler = () => {
    history.push(`/matchupdate/${match_id}`,{ TechQCSubmit: true });
  };

  useEffect(() => {
    window.addEventListener("keydown", initialHandleUserKeyPress);
    window.addEventListener("keyup", () => ClearSeekFlag());
    window.addEventListener("resize", () => getWidth());
    return () => {
      window.removeEventListener("keydown", initialHandleUserKeyPress);
      window.removeEventListener("keyup", () => ClearSeekFlag());
      return () => window.removeEventListener("resize", () => getWidth());
    };
  }, [initialHandleUserKeyPress]);

  const currentAnalyst = matchDetails?.analyst_details?.find((a) => Number(a?.id) === Number(props?.analystId));

  if (loading) {
    return (
      <Box sx={{ width: "100%", height: "100vh", display: "flex", flexDirection: "column", backgroundColor: "var(--app-bg)", overflow: "hidden" }}>
        <Stack direction="row" alignItems="center" sx={{ px: 3, py: 1.5, borderBottom: "1px solid var(--border-1)", backgroundColor: "var(--surface-1)" }}>
          <Skeleton variant="circular" width={32} height={32} sx={{ mr: 2, bgcolor: "var(--surface-2)" }} />
          <Skeleton variant="text" width={300} sx={{ bgcolor: "var(--surface-2)" }} />
        </Stack>
        <Stack direction="row" sx={{ flex: 1, p: 2, gap: 2 }}>
          <Skeleton variant="rounded" sx={{ flex: 1, borderRadius: "12px", bgcolor: "var(--surface-2)" }} />
          <Skeleton variant="rounded" width={320} sx={{ borderRadius: "12px", bgcolor: "var(--surface-2)" }} />
        </Stack>
      </Box>
    );
  }

  const isYoutubeUrl = () => {
    if (props?.videoUrl) {
      try {
        return new URL(props.videoUrl).hostname.includes("youtube.com");
      } catch {
        return false;
      }
    }
    return false;
  };

  // Watermark over the video whenever the Analysis Keyboard is not connected.
  // `isActive` mirrors the analysis event status (start/resume vs pause/none),
  // so this stays up even after the analyst closes the "Analysis Paused" dialog.
  const renderKeyboardWatermark = (position) =>
    !isActive || !keyboardScreenConnected ? (
      <Box
        sx={{
          position,
          inset: 0,
          zIndex: 4,
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center",
          pt: 2,
          pointerEvents: "none",
        }}
      >
        <Stack
          alignItems="center"
          gap={0.75}
          sx={{
            px: 3,
            py: 1.5,
            borderRadius: "12px",
            border: "1px dashed rgba(255,255,255,0.22)",
            backgroundColor: "rgba(0,0,0,0.3)",
            maxWidth: "90%",
            textAlign: "center",
          }}
        >
          <KeyboardAlt sx={{ fontSize: 26, color: "rgba(255,255,255,0.6)" }} />
          <Typography
            sx={{
              fontSize: "15px",
              fontWeight: 800,
              letterSpacing: "0.6px",
              textTransform: "uppercase",
              color: "rgba(255,255,255,0.72)",
            }}
          >
            Analysis Keyboard not connected
          </Typography>
          <Typography sx={{ fontSize: "11px", color: "rgba(255,255,255,0.55)" }}>
            {!keyboardScreenConnected
              ? "Tagging screen is not connected for this match"
              : "Open Analysis Keyboard to start tagging"}
          </Typography>
        </Stack>
      </Box>
    ) : null;

  const ablyConnectionBanner = ablyOffline ? (
    <Stack
      direction="row"
      alignItems="center"
      gap={1.5}
      sx={{
        position: "fixed",
        top: 16,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 2147483647,
        px: 2,
        py: 1.25,
        borderRadius: "10px",
        backgroundColor: "rgba(185, 28, 28, 0.97)",
        border: "1px solid rgba(255,255,255,0.18)",
        boxShadow: "0 8px 24px rgba(0,0,0,0.35)",
        maxWidth: "92vw",
        pointerEvents: "auto",
      }}
    >
      <WifiOff sx={{ fontSize: 18, color: "#fff" }} />
      <Stack sx={{ minWidth: 0 }}>
        <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "#fff" }}>
          Connection lost — playback paused
        </Typography>
        <Typography sx={{ fontSize: "11px", color: "rgba(255,255,255,0.8)" }}>
          {ablyRetrying
            ? "Reconnecting…"
            : "Playback is locked until the connection returns — it resumes automatically."}
        </Typography>
      </Stack>
      <Button
        size="small"
        variant="contained"
        disabled={ablyRetrying}
        onClick={handleAblyRetry}
        startIcon={<Refresh sx={{ fontSize: "16px !important" }} />}
        sx={{
          textTransform: "none",
          borderRadius: "8px",
          fontSize: "12px",
          fontWeight: 700,
          whiteSpace: "nowrap",
          backgroundColor: "#fff",
          color: "rgba(185, 28, 28, 1)",
          "&:hover": { backgroundColor: "rgba(255,255,255,0.88)" },
          "&.Mui-disabled": {
            backgroundColor: "rgba(255,255,255,0.55)",
            color: "rgba(185, 28, 28, 0.7)",
          },
        }}
      >
        {ablyRetrying ? "Retrying…" : "Retry"}
      </Button>
    </Stack>
  ) : null;

  return (
    <Box sx={{ width: "100%", minHeight: "100vh", display: "flex", flexDirection: "column", backgroundColor: "var(--app-bg)", overflow: "hidden" }}>
      {/* Header */}
      <Stack
        direction="row"
        alignItems="center"
        sx={{ px: { xs: 2, md: 3 }, py: 1, borderBottom: "1px solid var(--border-1)", backgroundColor: "var(--surface-1)", gap: 1 }}
      >
        <IconButton size="small" onClick={() => history.goBack()} sx={{ color: "var(--text-2)", borderRadius: "6px", width: 30, height: 30, "&:hover": { backgroundColor: "var(--surface-2)" } }}>
          <ArrowBack sx={{ fontSize: 16 }} />
        </IconButton>
        <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "var(--text-1)" }}>#{match_id}</Typography>
        <Typography sx={{ fontSize: "12px", color: "var(--text-2)" }}>
          {matchDetails?.team_a_details?.name} vs {matchDetails?.team_b_details?.name}
        </Typography>
        {isActive && (
          <Chip label="LIVE" size="small" sx={{ ml: "auto", height: 20, fontSize: "10px", fontWeight: 700, backgroundColor: "#10B98120", color: "#10B981" }} />
        )}
      </Stack>

      {ablyConnectionBanner &&
        (fullscreenHost
          ? createPortal(ablyConnectionBanner, fullscreenHost)
          : ablyConnectionBanner)}

      {/* In fullscreen the watermark rides along in the top-layer host. */}
      {fullscreenHost &&
        createPortal(renderKeyboardWatermark("fixed"), fullscreenHost)}

      {/* Paused Modal */}
      <Dialog open={isModalOpen} PaperProps={{ sx: { borderRadius: "12px", minWidth: 380, border: "1px solid var(--border-1)" } }}>
        <DialogTitle sx={{ backgroundColor: "rgba(232, 108, 0, 0.08)", borderBottom: "2px solid rgba(232, 108, 0, 1)", py: 1.5 }}>
          <Typography sx={{ fontSize: "15px", fontWeight: 700, color: "rgba(185, 80, 0, 1)" }}>Analysis Paused</Typography>
        </DialogTitle>
        <DialogContent sx={{ py: 2 }}>
          <Typography sx={{ fontSize: "13px", color: "var(--text-2)", mt: 1 }}>{dialogBoxText}</Typography>
        </DialogContent>
        <DialogActions sx={{ px: 2, pb: 2, gap: 1 }}>
          <Button variant="outlined" size="small" onClick={getAnalysisStatus} sx={{ textTransform: "none", borderRadius: "8px", fontSize: "12px", borderColor: "var(--border-1)", color: "var(--text-2)" }}>Refresh</Button>
          <Button variant="contained" size="small" onClick={() => setIsModalOpen(false)} sx={{ textTransform: "none", borderRadius: "8px", fontSize: "12px", backgroundColor: "rgba(232, 108, 0, 1)", "&:hover": { backgroundColor: "rgba(200, 93, 0, 1)" } }}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Main Content */}
      <Stack direction={{ xs: "column", md: "row" }} sx={{ flex: 1, p: { xs: 1, md: 2 }, gap: 2, overflow: "auto" }}>
        {/* Left: Video */}
        <Stack sx={{ flex: 1, minWidth: 0, gap: 1.5 }}>
          {/* Video Player */}
          <Box sx={{ borderRadius: "12px", overflow: "hidden", border: "1px solid var(--border-1)", backgroundColor: "#000", position: "relative" }}>
            {noMatchVideo && !props.videoUrl && (
              <Stack
                alignItems="center"
                justifyContent="flex-end"
                gap={1}
                sx={{
                  position: "absolute",
                  inset: 0,
                  zIndex: 4,
                  minHeight: 260,
                  backgroundColor: "#000",
                  textAlign: "center",
                  px: 3,
                  pb: 4,
                }}
              >
                <VideocamOff sx={{ fontSize: 40, color: "rgba(255,255,255,0.55)" }} />
                <Typography sx={{ fontSize: "15px", fontWeight: 700, color: "rgba(255,255,255,0.85)" }}>
                  No match video available
                </Typography>
                <Typography sx={{ fontSize: "12px", color: "rgba(255,255,255,0.6)" }}>
                  This match has no video attached yet. Load a custom URL to continue.
                </Typography>
              </Stack>
            )}
            {!fullscreenHost && renderKeyboardWatermark("absolute")}
            {showUrlInput && (
              <Stack direction="row" alignItems="center" sx={{ position: "absolute", inset: 0, zIndex: 5, backgroundColor: "rgba(0,0,0,0.9)", px: 3, gap: 1.5 }}>
                <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#fff", whiteSpace: "nowrap" }}>Custom URL</Typography>
                <TextField size="small" fullWidth placeholder="Paste video URL" value={url} onChange={(e) => setUrl(e.target.value)}
                  InputProps={{ sx: { borderRadius: "8px", fontSize: "13px", backgroundColor: "rgba(255,255,255,0.1)", color: "#fff", "& fieldset": { borderColor: "rgba(255,255,255,0.2)" } } }}
                />
                <Button variant="contained" size="small" onClick={() => { props.LoadVideoUrl(url); setShowUrlInput(false); setReady(true); }}
                  sx={{ textTransform: "none", borderRadius: "8px", fontSize: "12px", backgroundColor: "rgba(232, 108, 0, 1)", whiteSpace: "nowrap" }}>Load</Button>
                <IconButton size="small" onClick={() => setShowUrlInput(false)} sx={{ color: "rgba(255,255,255,0.6)" }}>
                  <ArrowBack sx={{ fontSize: 16 }} />
                </IconButton>
              </Stack>
            )}
            <VideoPlayer
              cref={playerRef}
              url={props.videoUrl}
              controls={showControls}
              played={props.videoTime}
              muted={isMute}
              onSeek={(seconds) => {
                latestVideoTimeRef.current = seconds;
                UpdateVideoTime(seconds);
              }}
              onProgress={(e) => {
                !seeking && timelineState.current && timelineState.current.setTime(e);
                !seeking && UpdateVideoTime(e);
                if (useAblyVideoSync) {
                  const _publishedAt = benchmarkService.recordAblyPublish(e);
                  publishVideoTimestamp(match_id, props.analystId, e, props.videoControl, _publishedAt);
                }
              }}
              playing={props.videoControl}
              onPause={() => { timelineState.current && timelineState.current.pause(); SetVideoControl(false); }}
              onEnded={() => { timelineState.current && timelineState.current.pause(); SetVideoControl(false); }}
              onPlay={() => {
                if (ablyOfflineRef.current) {
                  hardPausePlayer();
                  SetVideoControl(false);
                  return;
                }
                SetVideoControl(true);
              }}
              onReady={() => setReady(true)}
              playbackRate={speed}
              onDuration={(t) => setDuration(t)}
            />
          </Box>

          {/* Timeline (seconds → ms for the editor) */}
          {showTimeline && ready && !isYoutubeUrl() && (
            <VideoTimelineEditor
              matchId={match_id}
              analystId={props.analystId}
              setShowTimeline={setShowTimeline}
              showTimeline={showTimeline}
              durationMs={duration * 1000}
              videoTimeMs={videoTime * 1000}
              isPlaying={videoControl}
              setTime={(e) => { UpdateVideoTime(e / 1000); if (playerRef.current) playerRef.current.seekTo(e / 1000); }}
              timelineState={timelineState}
            />
          )}

          {/* Controls Bar (also shown for YouTube videos) */}
          {ready && (
            <Stack sx={{ backgroundColor: "var(--surface-1)", border: "1px solid var(--border-1)", borderRadius: "12px", overflow: "hidden" }}>
              {/* Seekbar (seconds) */}
              <Stack direction="row" alignItems="center" sx={{ px: 1.5, pt: 1 }}>
                <input
                  type="range" value={props.videoTime} style={{ width: "100%", accentColor: "rgba(232, 108, 0, 1)" }}
                  min={0} max={duration || 0}
                  onMouseDown={handleSeekMouseDown} onChange={handleSeekChange} onMouseUp={handleSeekMouseUp}
                  onTouchStart={handleSeekMouseDown} onTouchEnd={handleSeekMouseUp}
                />
              </Stack>

              {/* Controls row */}
              <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ px: 2, py: 1, gap: 1 }}>
                {/* Left: Jump + Timestamp */}
                <Stack direction="row" alignItems="center" gap={1}>
                  <TextField
                    size="small" placeholder="HH:MM:SS" value={jumpTo} onChange={(e) => setJumpTo(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && jumpManually(jumpTo)}
                    InputProps={{
                      startAdornment: <InputAdornment position="start"><Timer sx={{ fontSize: 16, color: "var(--text-2)" }} /></InputAdornment>,
                      sx: { borderRadius: "8px", fontSize: "12px", width: "130px", height: 34, backgroundColor: "var(--surface-2)", "& fieldset": { borderColor: "var(--border-1)" } },
                    }}
                  />
                  <IconButton size="small" disabled={!jumpTo} onClick={() => jumpManually(jumpTo)}
                    sx={{ width: 30, height: 30, borderRadius: "6px", border: "1px solid var(--border-1)", color: "var(--text-2)" }}>
                    <NavigateNext sx={{ fontSize: 16 }} />
                  </IconButton>
                  <Chip label={<Duration seconds={props.videoTime} />} size="small"
                    sx={{ height: 28, fontSize: "12px", fontWeight: 600, fontFamily: "monospace", backgroundColor: "var(--surface-2)", color: "var(--text-1)", border: "1px solid var(--border-1)" }} />
                </Stack>

                {/* Center: Play/Pause */}
                <Button
                  variant="contained" disabled={ablyOffline}
                  onClick={() => { if (!ablyOffline) SetVideoControl(!videoControl); }}
                  startIcon={videoControl ? <Pause sx={{ fontSize: "18px !important" }} /> : <PlayArrow sx={{ fontSize: "18px !important" }} />}
                  sx={{ borderRadius: "10px", textTransform: "none", fontSize: "13px", fontWeight: 700, px: 4, height: 40, backgroundColor: "rgba(232, 108, 0, 1)", "&:hover": { backgroundColor: "rgba(200, 93, 0, 1)" } }}
                >
                  {videoControl ? "Pause" : "Play"}
                </Button>

                {/* Right: Speed + Icons */}
                <Stack direction="row" alignItems="center" gap={0.5}>
                  {SPEEDS.map((s) => (
                    <Box key={s} onClick={() => setSpeed(s)}
                      sx={{
                        width: 34, height: 28, borderRadius: "6px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer",
                        backgroundColor: speed === s ? "rgba(232, 108, 0, 1)" : "var(--surface-2)", border: speed === s ? "none" : "1px solid var(--border-1)",
                      }}
                    >
                      <Typography sx={{ fontSize: "10px", fontWeight: 600, color: speed === s ? "#fff" : "var(--text-2)" }}>{s}x</Typography>
                    </Box>
                  ))}
                  <IconButton size="small" onClick={full} sx={{ width: 28, height: 28, borderRadius: "6px", ml: 0.5, color: "var(--text-2)", "&:hover": { backgroundColor: "var(--surface-2)" } }}>
                    <Fullscreen sx={{ fontSize: 18 }} />
                  </IconButton>
                  <IconButton size="small" onClick={handleMute} sx={{ width: 28, height: 28, borderRadius: "6px", color: "var(--text-2)", "&:hover": { backgroundColor: "var(--surface-2)" } }}>
                    {isMute ? <VolumeOff sx={{ fontSize: 18 }} /> : <VolumeUp sx={{ fontSize: 18 }} />}
                  </IconButton>
                </Stack>
              </Stack>
            </Stack>
          )}

          {/* Bottom bar: URL + Timeline toggle */}
          <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ backgroundColor: "var(--surface-1)", border: "1px solid var(--border-1)", borderRadius: "10px", px: 2, py: 1 }}>
            <Stack direction="row" alignItems="center" gap={1} sx={{ flex: 1, minWidth: 0, overflow: "hidden" }}>
              <LinkIcon sx={{ fontSize: 16, color: "var(--text-2)", flexShrink: 0 }} />
              <Typography sx={{ fontSize: "12px", color: "var(--text-2)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {props.videoUrl || "No video loaded"}
              </Typography>
            </Stack>
            <Stack direction="row" gap={1}>
              <Button size="small" onClick={() => setShowUrlInput(true)} sx={{ textTransform: "none", fontSize: "11px", color: "var(--text-2)", borderRadius: "6px" }}>Load URL</Button>
              {/* {ready && !isYoutubeUrl() && (
                <Button size="small" variant={showTimeline ? "contained" : "outlined"} onClick={() => setShowTimeline(!showTimeline)}
                  sx={{ textTransform: "none", fontSize: "11px", borderRadius: "6px", ...(showTimeline ? { backgroundColor: "rgba(232, 108, 0, 1)", "&:hover": { backgroundColor: "rgba(200, 93, 0, 1)" } } : { borderColor: "var(--border-1)", color: "var(--text-2)" }) }}>
                  Timeline
                </Button>
              )} */}
            </Stack>
          </Stack>
        </Stack>

        {/* Right Sidebar */}
        <Stack sx={{ width: { xs: "100%", md: "320px" }, minWidth: "280px", gap: 2 }}>
          {/* Match Details Card */}
          <Stack sx={{ backgroundColor: "var(--surface-1)", border: "1px solid var(--border-1)", borderRadius: "12px", overflow: "hidden" }}>
            <Stack sx={{ px: 2, py: 1.5, backgroundColor: "var(--surface-2)", borderBottom: "1px solid var(--border-1)" }}>
              <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "var(--text-1)" }}>Match Details</Typography>
            </Stack>
            <Stack sx={{ p: 2, gap: 1.5 }}>
              <Stack>
                <Typography sx={{ fontSize: "15px", fontWeight: 700, color: "var(--text-1)" }}>
                  {match_id} {matchDetails?.team_a_details?.name} vs {matchDetails?.team_b_details?.name}
                </Typography>
                <Typography sx={{ fontSize: "11px", color: "var(--text-2)" }}>
                  {matchDetails?.tournament_name}
                </Typography>
              </Stack>

              <Stack direction="row" justifyContent="space-between" sx={{ px: 1.5, py: 1, borderRadius: "8px", backgroundColor: "var(--surface-2)" }}>
                <Typography sx={{ fontSize: "12px", color: "var(--text-2)" }}>Analyst</Typography>
                <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "var(--text-1)" }}>{currentAnalyst?.name || "—"}</Typography>
              </Stack>

              <Stack direction="row" justifyContent="space-between" sx={{ px: 1.5, py: 1, borderRadius: "8px", backgroundColor: "var(--surface-2)" }}>
                <Typography sx={{ fontSize: "12px", color: "var(--text-2)" }}>Game Time</Typography>
                <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "var(--text-1)" }}>{matchDetails?.game_time ? `${matchDetails.game_time} min` : "—"}</Typography>
              </Stack>

              <Stack direction="row" gap={1}>
                <Stack sx={{ flex: 1, px: 1.5, py: 1, borderRadius: "8px", border: "1px solid var(--border-1)", alignItems: "center" }}>
                  <Typography sx={{ fontSize: "10px", color: "var(--text-2)", fontWeight: 600 }}>Team A</Typography>
                  <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "var(--text-1)", textAlign: "center" }}>{matchDetails?.team_a_details?.name || "—"}</Typography>
                </Stack>
                <Stack sx={{ flex: 1, px: 1.5, py: 1, borderRadius: "8px", border: "1px solid var(--border-1)", alignItems: "center" }}>
                  <Typography sx={{ fontSize: "10px", color: "var(--text-2)", fontWeight: 600 }}>Team B</Typography>
                  <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "var(--text-1)", textAlign: "center" }}>{matchDetails?.team_b_details?.name || "—"}</Typography>
                </Stack>
              </Stack>
            </Stack>
          </Stack>

          {/* Elapsed Time Card */}
          <Stack direction="row" alignItems="center" gap={2} sx={{ backgroundColor: "var(--surface-1)", border: "1px solid var(--border-1)", borderRadius: "12px", px: 2, py: 1.5 }}>
            <Box sx={{ px: 1.5, py: 1, borderRadius: "8px", border: "1px solid var(--border-1)", backgroundColor: isActive ? "rgba(232, 108, 0, 0.08)" : "var(--surface-2)" }}>
              <Typography sx={{ fontSize: "20px", fontWeight: 700, fontFamily: "monospace", color: isActive ? "rgba(232, 108, 0, 1)" : "var(--text-1)", lineHeight: 1 }}>
                {formatTimeFromSeconds(time)}
              </Typography>
            </Box>
            <Stack>
              <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "var(--text-1)" }}>Elapsed Time</Typography>
              <Typography sx={{ fontSize: "11px", color: "var(--text-2)" }}>Analysis duration</Typography>
            </Stack>
          </Stack>

          {/* Action Buttons */}
          <Stack gap={1}>
            <Button
                          fullWidth variant="outlined"
                          onClick={() => history.push(`/match-details/${match_id}`)}
                          startIcon={<InfoOutlined sx={{ fontSize: "18px !important" }} />}
                          sx={{
                            borderRadius: "10px", textTransform: "none", fontSize: "14px", fontWeight: 600, py: 1.25,
                            borderColor: "var(--border-1)", color: "var(--text-1)",
                            "&:hover": { borderColor: "var(--text-2)", backgroundColor: "var(--surface-2)" },
                          }}
                        >
                          Details
                        </Button>
            {/* Tagging is live while the keyboard screen is in the room — moving
                on to Tech QC now would QC a string still being written.
                The span keeps the tooltip working over a disabled button. */}
            <Tooltip
              title={keyboardScreenConnected ? "Analysis is in progress" : ""}
              placement="top"
              arrow
            >
              <span style={{ width: "100%" }}>
                <Button
                  fullWidth variant="contained" disabled={keyboardScreenConnected}
                  onClick={() => history.push("/techQC/" + match_id)}
                  startIcon={<BugReport sx={{ fontSize: "18px !important" }} />}
                  endIcon={<NavigateNext sx={{ fontSize: "18px !important" }} />}
                  sx={{
                    borderRadius: "10px", textTransform: "none", fontSize: "14px", fontWeight: 700, py: 1.25,
                    backgroundColor: "rgba(232, 108, 0, 1)",
                    "&:hover": { backgroundColor: "rgba(200, 93, 0, 1)" },
                    "&.Mui-disabled": { backgroundColor: "var(--surface-2)", color: "var(--text-2)" },
                  }}
                >
                  Next Step
                </Button>
              </span>
            </Tooltip>
            {showDeploymentBtn && (
              <Button
                fullWidth variant="contained" onClick={gotoSubmitHandler}
                startIcon={<RocketLaunch sx={{ fontSize: "18px !important" }} />}
                endIcon={<NavigateNext sx={{ fontSize: "18px !important" }} />}
                sx={{ borderRadius: "10px", textTransform: "none", fontSize: "14px", fontWeight: 700, py: 1.25, backgroundColor: "#059669", "&:hover": { backgroundColor: "#047857" } }}
              >
                Proceed to Deployment
              </Button>
            )}
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};
const mapStateToProps = (state) => {
  return {
    videoControl: state.control.videoControl,
    videoUrl: state.control.videoUrl,
    videoTime: state.control.videoTime,
    all_matches: state.match.all_matches,
    currentAction: state.control.currentAction,
    analysedString: state.control.analysedString,
    actionLog: state.control.actionLog,
    seekToTime: state.control.seekToTime,
    analystId: state.auth.analyst_id,
  };
};

export default connect(mapStateToProps, {
  UpdateVideoTime,
  LoadVideoUrl,
  SetVideoControl,
  SaveMatchString,
  SetControllerToggle,
  ClearSeekFlag,
})(VideoTab);

